import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FileListComponent } from 'src/app/CommonComponents/file-list/file-list.component';
import { CommonService } from 'src/app/Service/Common.service';
import { FileService, FileUploadLibrary } from 'src/app/Service/file/file.service';
import { ITransmittalDetailsModel, ITransmittalDocViewModel } from 'src/app/ViewModel/TransmittalModel';
import { ITransmittalDistributionViewModel } from 'src/app/ViewModel/TransmittalTemplateModel';
import { TransmittalTemplateComponent } from '../../transmittal-template/transmittal-template.component';
import { environment } from 'src/environments/environment';
import { TransmittalMsgService } from 'src/app/Service/transmittal/transmittal.service';
import { LoaderService } from 'src/app/Service/Loader/loader.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { WorkflowTemplateDialogModel } from 'src/app/ViewModel/WorkflowTemplateDialogModel';
import { formatDate } from '@angular/common';
import { IMemebersViewModel } from 'src/app/ViewModel/MembersModel';
import { ExternalMemberService } from 'src/app/Service/member/external-member.service';
import { IMsgDocumentAttachmentModel } from 'src/app/ViewModel/CommunicationModel';

@Component({
  selector: 'app-transmittal-template',
  templateUrl: './transmittal-template-common.component.html',
})
export class CommonTransmittalTemplateComponent implements TransmittalTemplateComponent, OnInit {
  templateName!: string;
  message_id?: number;
  message_No?: any;
  to!: string;
  date!: string;
  edrcRef!: string;
  cusRef!: string;
  projName!: string;
  subject!: string;
  attention!: string;
  From!: string;
  message_Note!: string;
  currentproject!: ProjectViewModel;
  lntDescriptionInPage: string = "LARSEN AND TOUBRO LTD";
  docDetails!: ITransmittalDocViewModel[];
  distributionDetails!: ITransmittalDistributionViewModel[];
  fileDetails!:any[];
  public memberId: number = 0;
  public projectId!: number;
  public groupId!: number;
  public icId?: number;
  public redirectUri: string = "";
  public hyperlink: string = "";
  imagePath: string = environment.currentServer;
  public is_Show_Attachment_In_DTN!: boolean;
  public task_id_list!: string;
  public workflowId!: number;

  public RespondOn: string = formatDate(new Date(), 'dd-MM-yyyy', 'en-US');
  transmittalList: ITransmittalDetailsModel[] = [];
  public groupDetails: any;
  public receiverDetails: any;
  public currentWorkflowDetails!: WorkflowTemplateDialogModel;
  public mailReceiverDetails: any[] = [];
  public membersList: IMemebersViewModel[] = [];
  public canManualNo: boolean = false;
  public dtnList: any[] = [];
  public transmittalNo: any = null;
  public toMember: any[] = [];
  public ccMember: any[] = [];
  public fromMember: any[] = [];

  constructor(private _notificationService: NotificationService, public memberService: ExternalMemberService, private loaderService: LoaderService, private dialog: MatDialog, private commonService: CommonService, private _transmittalService: TransmittalMsgService, private _WorkflowTemplateService: WorkflowTemplateService,private _fileService:FileService) { }

  ngOnInit() {
    this.memberId = this.commonService.getLoggedInUserId();
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.currentproject = this.commonService.getCurrentProjectDetails();
    this.icId = this.currentproject.icId
    this.redirectUri = environment.currentServer;
    this.workflowId = this.docDetails[0].workflowId;
    if (this.message_id && this.message_id > 0) {
      this.hyperlink = this.redirectUri + 'authentication/mail-redirect-handler?project=' + this.projectId + '&page=transmittal-list&msg=' + this.message_id
    }

    switch (this.icId) {
      case 13312:
        this.imagePath = this.imagePath + "/assets/images/bnf-logo.jpg";
        break;
      case 88:
        this.imagePath = this.imagePath + "/assets/images/hcl-logo.png";
        break;
      default:
        this.imagePath = this.imagePath + "/assets/images/lnt-logo.png";
        break;
    }
    if (this.workflowId)
      this.GetWorkflowtemplate(this.workflowId);

  }
  getDocCategory(doc: ITransmittalDocViewModel): string {
    if (!!doc.category)
      return doc.category.dedShortDescription;
    return "";
  }

  getDocType(doc: any): string {
    if (!!doc.type)
      return doc.type.dedShortDescription;
    return "";
  }

  async viewAttachmentClick(data: ITransmittalDocViewModel) {
    if (!this.workflowId && data.workflowId)
      await this.GetWorkflowtemplate(data.workflowId);
    let _libNum = this.getLibNum(data);
    if (this.message_id && this.message_id > 0) {
      this.dialog.open(FileListComponent, {
        panelClass: 'mat-dialog-secondary',
        width: '70%',
        data: { projectId: this.projectId, messageId: this.message_id, docId: data.doc_Id, revisionNo: data.revision_No, libraryName: _libNum, createdBy: this.memberId, isDeleteEnable: false, documentNo: this.message_No, task_ID: data.task_Id },
      });
    }
    else {
      this.dialog.open(FileListComponent, {
        panelClass: 'mat-dialog-secondary',
        width: '70%',
        data: { projectId: this.projectId, messageId: -1, docId: data.doc_Id, revisionNo: data.revision_No, libraryName: _libNum, createdBy: this.memberId, isDeleteEnable: data.scheduleType == 3 ? false : true, documentNo: this.message_No, task_ID: data.task_Id},
      });
    }
  }

  downloadAll_OnClick(isfileDownload?:boolean) {
    this.loaderService.isLoading.next(true);

    if(isfileDownload)
    {
      let fileInput_Communication = {
        projectId: this.projectId,
        messageId: this.message_id,
      }
      this._fileService.DownloadAllFiles([{ libraryNumber: 4, value: JSON.stringify(fileInput_Communication) }]).subscribe((data:Blob) => {
        this.loaderService.isLoading.next(false);
        const downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(data);
        downloadLink.download = this.message_No +'- CommonFiles' + ".zip";
        downloadLink.click();
        document.body.removeChild(downloadLink);}, error => {
        this.loaderService.isLoading.next(false);
        this._notificationService.showToast("Error in downloading attachment, try after some time", "Warning");
      });
    }
    else{
      this._transmittalService.DownloadAllAttachments(this.projectId, this.message_id, (this.is_Show_Attachment_In_DTN ? FileUploadLibrary.WorkflowDocument : FileUploadLibrary.SignedDocuments), this.message_No + ".zip").subscribe((data: any) => {
        this.loaderService.isLoading.next(false);
        const downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(data);
        downloadLink.download = this.message_No + '- DocumentAttachmentFiles' + ".zip";
        downloadLink.click();
        document.body.removeChild(downloadLink);}, error => {
        this.loaderService.isLoading.next(false);
        this._notificationService.showToast("Error in downloading attachment, try after some time", "Warning");
      });
    }
  }
  GetWorkflowtemplate(workflowId: number): Promise<any> {
    return this._WorkflowTemplateService.getWorkflowTemplate(workflowId).toPromise().then((data: WorkflowTemplateDialogModel) => {
      if (data)
        if (data.workflowStatus && data.workflowStatus.some(x => x.is_Show_Attachment_In_DTN == true))
          this.is_Show_Attachment_In_DTN = true;
      this.task_id_list = data.workflowStatus.filter(x => x.is_Show_Attachment_In_DTN == true).map(y => y.task_Id).join();
    });
  }
  getLibNum(data?: any): number {
    let _libNum = (data.scheduleType == 3 || this.is_Show_Attachment_In_DTN ? FileUploadLibrary.WorkflowDocument : FileUploadLibrary.SignedDocuments);
    return _libNum;
  }


  download_OnClick(doc:IMsgDocumentAttachmentModel)
  {
    this._fileService.DownloadFile({ libraryNumber: 4, fileId: doc.fileId, fileName: doc.fileName+'.'+doc.fileExtension }).subscribe((res: any) => {
      this.loaderService.isLoading.next(false);
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(res);
      downloadLink.download = doc.fileName+'.'+doc.fileExtension;
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }, err => {
      this.loaderService.isLoading.next(false);
      this._notificationService.showToast("Error in downloading attachment, try after some time", "Warning");
    })
  }
}
